import React, {useState, useEffect} from 'react'
// Styles
import './msk.style.css'
// Actions
import { Base_API } from '../../_actions/matcher'
import { NhealthAction } from '../../_actions/action.api'
// Components
import MyBasket_ListCard from '../../components/MyBasket_ListCard';
import MyBasket_TabConfirmOrder from '../../components/MyBasket_TabConfirmOrder';
import { useParams } from 'react-router-dom';
import { DecryptedOBJ } from '../../utils/Encryption';


function MyBasket(props) {
    const { ref } = useParams(); 

    const [loading, setLoading] = useState(true);
    const [packOrder, setPackOrder] = useState(null);
    const [totalPrice, setTotalPrice] = useState(0);
    const [quantitySelected, setQuantitySelected] = useState(0);
    const [cartData, setCartData] = useState(null);
    const [calCartData, setCalCartData] = useState(null);

    useEffect(() => {
        dataInit();
    },[])

    const dataInit = async() => {
        let campaignData = await campaignInit();
        let mem_id = await checkUserInit();
        await calCartInit(campaignData,mem_id);
        handleLoader('inactive'); 
    }

    const calCartInit = (campaignData, membercode) => {
        return new Promise(async resolve => {
            NhealthAction.CalCart(campaignData.id, 0, membercode)
            .then(res => {
                if(res.isSuccess === true)
                {
                    // console.log('Calculate Cart: ',res); 
                    setCartData(res.cart);
                    setCalCartData(res);
                    resolve();
                }else
                {
                    onBack();
                }
            })
        })
    }

    const checkUserInit = () => {
        return new Promise(async resolve => {
            let line_profile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            if(line_profile !== null)
            {
                NhealthAction.GetMember(line_profile.user_id)
                .then(res => {
                    if(res.isSuccess === true)
                    {
                        resolve(res.member.membercode);
                    }else
                    {
                        resolve(line_profile.user_id);
                    }
                })
            }else
            {
                onBack();
            }
        })
    } 

    const onBack = () => {
        window.location.href = `${Base_API.pathWeb}/n-health/packages/${ref}`;
    }

    const campaignInit = () => {
        return new Promise(async resolve => {
            NhealthAction.GetCampaign(ref).then(data => {
                resolve(data.campaign);
            })
        })
    }

    const handleLoader = (status) => {
        if(status === 'inactive')
        {
            setLoading(false);
        }else
        {
            setLoading(true);
        }
    }

    const handlerDeleteCartByID = (cardID) => {
        NhealthAction.DeleteCart(cardID)
        .then(res => {
            if(res.isSuccess === true)
            {
                window.location.reload();
            }
        })
    }

    if(loading)
    {
        return (
            <div className="sls-loader-container">
                <div className="sls-loader"></div>
            </div>
        )
    }else
    {
        return (
            <div className='mybsk-container'>
                <div className="head-wrap">
                    {/* header test */}
                    <h1 className="header-text">ตะกร้ารายการ</h1>
                    {/* clear basket */}
                    {/* <p 
                        className="clear-basket t-normal"
                    >
                        ล้างข้อมูล
                    </p> */}
    
                </div>
    
                {/* Basket Lists */}
                <div className="bsk-list-wrap">
                    {cartData !== null &&
                        cartData.map((item, i) => 
                            <MyBasket_ListCard 
                                packageData={item} 
                                handlerDeleteCartByID={handlerDeleteCartByID}
                                key={i} 
                            />
                        )
                    }
                </div>
    
                {/* Basket Tab Confirm Order */}
                <MyBasket_TabConfirmOrder 
                    quantitySelected={quantitySelected} 
                    totalPrice={totalPrice}
                    calCartData={calCartData}
                    refCampaign={ref}
                    type={'packages'}
                />
            </div>
        )
    }
}

export default MyBasket